import { z } from "zod";

export const documentSchema = z.object({
  id: z.number(),
  file_name: z.string(),
  file_path: z.string(),
});

export const documentUploadSchema = z.object({
  document: z
    .any()
    .refine((value) => value !== null, {
      message: "ドキュメントは必須です。",
    })
    .refine((value) => value instanceof File, {
      message: "ドキュメントはファイルオブジェクトでなければなりません。",
    })
    // file types .pdf,.jpeg,.png,.jpg,.doc,.docx,.xls,.xlsx,.ppt,.pptx
    .refine(
      (value) => {
        const allowedTypes = [
          "application/pdf",
          "image/jpeg",
          "image/png",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ];
        return value !== null && allowedTypes.includes(value.type);
      },
      {
        message: "無効なドキュメントタイプ",
      },
    ),
  name: z.string().min(1, { message: "ファイル名を入力してください。" }),
});

export const documentIdSchema = z.object({
  id: z.number(),
});

export type DocumentId = z.infer<typeof documentIdSchema>;

export type Document = z.infer<typeof documentSchema>;
export type DocumentUpload = z.infer<typeof documentUploadSchema>;
